/**
 * Stores build information. The string literals are replaced at compile time by `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-08-07",
    versionChannel: "nightly",
    buildDate: "2024-08-07T00:05:27.230Z",
    commitHash: "3357904d1ec7ea74201e484e7f6943a3d05dba99",
};
